
export class ComCommodityEntryEntity {
    id:number;
    number:string;
    customerId:number;
    customerName:string;
    city:string;
    origin:string;
    originType:string;
    agentIdentification:string;
    state:string;
    automatic:boolean;
    userId:number;
    userName:string;
    creationDate:String;
    active:boolean;
    approvedUserId:number;
    approvedDate:string;
    
    constructor() { }
}